/* generated by pull.js */
const manifest = {
  "editorOnly": true,
  "name": "Autosave",
  "description": "Automatically saves your projects to local files at regular intervals to prevent data loss.",
  "credits": [
    {
      "name": "Mistium",
      "link": "https://mistium.com"
    }
  ],
  "userscripts": [
    {
      "url": "userscript.js"
    }
  ],
  "userstyles": [
    {
      "url": "style.css"
    }
  ],
  "settings": [
    {
      "dynamic": true,
      "name": "Enable autosave",
      "id": "enabled",
      "type": "boolean",
      "default": true
    },
    {
      "dynamic": true,
      "name": "Autosave interval (minutes)",
      "id": "interval",
      "type": "integer",
      "default": 5,
      "min": 1,
      "max": 60
    },
    {
      "dynamic": true,
      "name": "Show save notifications",
      "id": "showNotifications",
      "type": "boolean",
      "default": true
    },
    {
      "dynamic": true,
      "name": "Save only when project is changed",
      "id": "saveOnlyWhenChanged",
      "type": "boolean",
      "default": true
    }
  ],
  "tags": ["editor", "featured", "MistWarp"],
  "enabledByDefault": false
};

export default manifest;
